'use client'

import { useTheme } from '@mui/material/styles';
import { Avatar, Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from '@/app/store';
import { openDrawer } from '@/app/store/slices/menu';
import { useRouter } from 'next/navigation';
import swal from "sweetalert";
import Swal from "sweetalert2";
import { useIntl } from "react-intl";
import { useIdle } from 'react-use';

import LogoSection from '../LogoSection';
import SigucVersion from './SigucVersionSection';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';
import MobileSection from './MobileSection';
import LocalizationSection from './LocalizationSection';
import MegaMenuSection from './MegaMenuSection';

import { deconnection } from '@/app/global-functions/UserEnLigneLogOut';
import { getUniversityName } from '@/app/global-functions/getUniversityName';
import { handleRedirection } from '@/app/global-functions/handleRedirection';
import { IconMenu2 } from '@tabler/icons-react';
import { getAcademicYear, getAcademicYearProfApi, getAllAnneeAcademique, getAllAnneeAcademiqueStudents, getAllStudentCoursAccessEstudantStudentApi, getAllUser, getAllUserAdministracao, getCalendarioAvaliation, getCalendarioAvaliationProfApi, getCoursDuration, getCoursDurationProfApi, getCoursDurationStudentApi, getCoursProfProfApi, getCurrencyAll, getFaculty, getFacultyCandidatures, getFacultyForConfigOnly, getPAymentCaisseStudentStudentApi, getPaymentsmouvementsStudentApi, getSaldoEstudentStudentApi, getTurma, getTurmaProfApi, getTurno, getTurnoProfApi, getUniversity, getUniversityStudentApi, getYearStudentCoursDistinctStudentApi, gteDepartement, setParamMemoire } from '@/app/store/slices/diversParametersRedux';
import { getUserEmailUpdateData } from '@/app/services/admin/UserLogin.services';
import { getBaseURL } from '@/app/global-functions/baseURLUtils-administrators';
import { getSocket } from '@/app/global-functions/getSocket';

import ShowSessionExpiredAlert from '@/app/global-functions/ShowSessionExpiredAlert';

import PopupNew from '@/app/views/pages/diversosComponents/PopupNew';
import UserService from '@/app/services/admin/User.service';
import { deconnectionEtudiantApi } from '@/app/global-functions/UserEnLigneLogOutStudentApi';
import { logouAllSystem } from '@/app/global-functions/logout/logouAllSystem';

const Header = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useRouter();
  const intl = useIntl();

  const { drawerOpen } = useSelector((state) => state.menu);
  const { paramMemoire } = useSelector((state) => state.diversParametersRedux);
  
  const [role, setRole] = useState(0);
  const [alterarSenha, setAlterarSenha] = useState(1);
  const [userID, setUserID] = useState(0);
  const [closingFromTimerOut, setClosingFromTimerOut] = useState(false);
  const [isDisconnecting, setIsDisconnecting] = useState(false);

  const idleTime = 1000 * 60 * 10; // 1 minute idle time
  const debounceTime = 500;
  

  const isIdle = useIdle(idleTime);
  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);
  const [universityID, setUniversityID] = useState("");
  const [universityIDDisplay, setUniversityIDDisplay] = useState("");

  const [abreviaturaUniversidade, setAbreviaturaUniversidade] = useState("");
  
  const [isLogged, setisLogged] = useState(false);
  const [userEmail, setuserEmail] = useState("");
  const [url, setUrl] = useState(getBaseURL());  // backend URL
  const [idleState, setIdleState] = useState(false); // Custom state to manage idle logic

  const [showExpiredComponent, setshowExpiredComponent] = useState(false); // Custom state to manage idle logic

  const [typeUtilisateur, settypeUtilisateur] = useState("");

  const [userIDStudent, setuserIDStudent] = useState("");

  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");

  const [universityOuCollege, setuniversityOuCollege] = useState("");

  
  useEffect(() => {
    fetchUniversityName();

  }, []);

 
 /*  useEffect(() => {
    const performCleanup = () => {

      if (Number(typeUtilisateur) >= 3) {
        const disconnect = {
          enligne: 0,
          disconectBeforeConnect: 0,
          tipo: "userUpdateEnLigneDisocnnectStudent",
          userID: userIDStudent,
        };

        UserService.updateStudent(userID, disconnect)
          .then(async () => {
            await deconnectionEtudiantApi(userID, 0, 0); // Disconnect from deliberation and online system
            await logouAllSystem();
            handleRedirection(abreviaturaUniversidade, navigate);
          })
          .catch((error) => console.error("Error updating student disconnect status:", error));
      } else {
        const disconnect = {
          enligne: 0,
          disconectBeforeConnect: 0,
          tipo: "updateEnLigneNew",
          userID,
        };

        UserService.update(userID, disconnect)
          .then(async () => {
            await deconnection(userID, 0, 0, firstname, lastname); // Disconnect from deliberation and online system
            await logouAllSystem();
            handleRedirection(abreviaturaUniversidade, navigate);
          })
          .catch((error) => console.error("Error updating user disconnect status:", error));
      }
    };

    const handleTabClose = (event) => {
      const confirmClose = window.confirm(intl.formatMessage({ id: "quitter_futuriss_sans_logout" }));
      if (!confirmClose) {
        // Prevent the tab from closing
        event.preventDefault();
        event.returnValue = ""; // Triggers the browser's default warning dialog
        performCleanup();
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        console.log("Tab or app is being hidden. Performing cleanup...");
        performCleanup();
      }
    };

    // Add event listeners for both desktop and mobile scenarios
    window.addEventListener("beforeunload", handleTabClose); // Desktop/tab close
    document.addEventListener("visibilitychange", handleVisibilityChange); // Mobile/tab switch

    return () => {
      // Clean up event listeners
      window.removeEventListener("beforeunload", handleTabClose);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [typeUtilisateur, userID, userIDStudent, abreviaturaUniversidade, navigate, firstname, lastname, intl]);
 */
/* 
  useEffect(() => {
    const handleTabClose = async () => {
      console.log('Tab is being closed.');
      if(Number(typeUtilisateur) >=3) {

        const disconnect = {
          enligne : 0,
          disconectBeforeConnect : 0,
          tipo : "userUpdateEnLigneDisocnnectStudent",
          userID:  userIDStudent,
        }

       await  UserService.updateStudent(userID, disconnect).
        then(async(response) => {

      await   deconnectionEtudiantApi(userID, 0, 0); // deconnexion de la salle de deliberation et du ssystem en ligne
      
      await logouAllSystem();

      handleRedirection(abreviaturaUniversidade, navigate);
 
        })
      
      }else {

        const disconnect = {
          enligne : 0,
          disconectBeforeConnect : 0,
          tipo : "updateEnLigneNew",
          userID,
        }
       await  UserService.update(userID, disconnect).
        then(async(response) => {

          await  deconnection(userID, 0, 0, firstname, lastname); // deconnexion de la salle de deliberation et du ssystem en ligne

          await logouAllSystem();

          await   handleRedirection(abreviaturaUniversidade, navigate);
    
        })
      
      }

    };
  
    window.addEventListener('unload', handleTabClose);
  
    return () => {
      window.removeEventListener('unload', handleTabClose);
    };
  }, []);  */


  useEffect(() => {
    if (Number(userID) >0) {
     //  console.log("userID###################   ", userID);
    //  console.log("isLogged###################   ", isLogged)

      const socket = getSocket(url);

      socket.on("connect", () => {
      //   console.log("Connected to WebSocket:", socket.id);
      //  console.log("Emitting userOnline event with userID:", userID);
        socket.emit("userOnline", { userID });
      });

      socket.on("disconnect", (reason) => {
               //  alert("stopsocket1")

        console.log("Disconnected from WebSocket:", reason);
    });

     //  console.log("######################################aweqwewew");

      return () => {
       //  console.log("Cleaning up WebSocket...");
        socket.off("connect");
        socket.off("disconnect");

      };
    }
  }, [userID, alterarSenha]);

 /*  useEffect(() => {
    if (!isLogged && Number(userID) > 0) {
      const socket = getSocket(url);
  
      console.log("isIdle###### ", isIdle);
      console.log("isDisconnecting### ", isDisconnecting);
      console.log("userID### ", userID);
  
      // Perform logout logic
      setUserID(0);
      setisLogged(false);
      setIsDisconnecting(true); // Prevent further calls
      setClosingFromTimerOut(true);
  
      // Perform additional cleanup or state updates
      dataSetAll();
  
      if (socket) {
      //  console.log("Emitting disconnectUser event...");
     //   socket.emit("disconnectUser", { socketId: socket.id, userID });
  
        console.log("Socket disconnecting...");
        socket.on("disconnect", (reason) => {
       //   console.log("Socket disconnected with reason:", reason);
        });

        socket.off("connect");
        socket.off("disconnect");
        setisLogged(false);

        alert("beforeDisconnected####")
  
        // Redirect to sessionExpiredAlert page
        const queryParams = new URLSearchParams({
          abreviaturaUniversidade,
          onConfirm: true,
          userID,
        }).toString();
  
        navigate.push(`/sessionExpiredAlert/?${queryParams}`); // Navigate to new page
     
      } else {
        console.error("Socket instance is not initialized.");
      }
    }
  }, [isLogged]); */


  const fetchUniversityName = async () => {
    const university = await getUniversityName();
    setAbreviaturaUniversidade(university.abreviatura);
  };


  const fetchProfessorDataProf = async (universityID, currentYear, professorID) => {
   
    setImmediate(() => {
      Promise.all([
        dispatch(getTurnoProfApi("General-san-filter")),
        dispatch(getAcademicYearProfApi("General-san-filter")),
        dispatch(getTurmaProfApi("General-san-filter")),
        dispatch(getCoursProfProfApi(universityID, currentYear, professorID, "searchByprofesseurIDGeneral")),
        dispatch(getCoursDurationProfApi("All_coursDuration", universityID)),
        dispatch(getCalendarioAvaliationProfApi(1, "getAllCalendario", universityID))
      ])
      .catch(error => console.error("Error in Promise.all:", error));
    });
    
    // Return immediately to avoid blocking
    return Promise.resolve();

   /*  return Promise.all([
      dispatch(getTurnoProfApi("General-san-filter")),
      dispatch(getAcademicYearProfApi("General-san-filter")),
      dispatch(getTurmaProfApi("General-san-filter")),
      dispatch(getCoursProfProfApi(universityID, currentYear, professorID, "searchByprofesseurIDGeneral")),
      dispatch(getCoursDurationProfApi("All_coursDuration", universityID)),
      dispatch(getCalendarioAvaliationProfApi(1, "getAllCalendario", universityID))
    ]); */

  };

  const handleOnIdle = async () => {

   // if (isDisconnecting) return; // Prevent multiple invocations

    setIsDisconnecting(true); // Set flag to prevent further calls
    setClosingFromTimerOut(true);
    const socket = getSocket(url);

    if (isIdle) {

    //   console.log("isDisconnecting###### ", isDisconnecting)
     //   console.log("isLogged###### ", isLogged)

      if(isLogged) {
     
        socket.emit('disconnectUser', { socketId: socket.id, userID });

       //  console.log('Socket disconnecting...');
        socket.disconnect();
       //  setIdleState(false); // Reset idle state to prevent re-triggering


       //  if(isDisconnecting) {
        await deconnection(userID, 0, 0); // Call the disconnection only once

       //  alert("777777777777")
       //  setIdleState(false);
     // }
     //  setIsDisconnecting(true);
      const response = await getUserEmailUpdateData(userEmail);
          const testData = response.data;
  
           setParamMemoire([
            {
              ...testData.user, // Spreading all existing properties of the user object
              isLoggedIn2: false, // Adding or overriding the `isLoggedIn2` property
            },
          ]) 


         //  alert("chegouaqui0000000")

     //  await  dispatch(setParamMemoire([{...testData.user,
    //    isLoggedIn2: false
     //   }])); 

       //  alert("chegouaqui")

        setisLogged(false);


     /*  Swal.fire({
        title: intl.formatMessage({ id: "mensagem_erro_menu_atencao" }),
        text: intl.formatMessage({ id: "session_expire" }),
        icon: 'warning',
        confirmButtonText: 'OK', 
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await handleRedirection(abreviaturaUniversidade, navigate);
        //   setIsDisconnecting(false); // Reset flag after disconnection
        }
      }); */

    }
  };
}

  useEffect(() => {
    
    const debounceTimeout = setTimeout(() => {
      if (isIdle) {
        const socket = getSocket(url);

        setupTimer();
        setIsDisconnecting(true);
      //   handleOnIdle();
        setUserID(0);

        socket.off("connect");
        socket.off("disconnect");
        setisLogged(false);
        clearTimer();
      //  alert("beforeDisconnected####")
  
        // Redirect to sessionExpiredAlert page
        const queryParams = new URLSearchParams({
          abreviaturaUniversidade,
          onConfirm: true,
          userID,
        }).toString();

        getdadosLoginFalse();

        navigate.push(`/sessionExpiredAlert/?${queryParams}`); // Navigate to new page
     
        return () => clearTimeout(debounceTimeout);
      //  setIdleState(false); // Reset idle state to prevent re-triggering

      } else {
        clearTimer();
      }
    }, debounceTime);
    return () => clearTimeout(debounceTimeout);
  }, [isIdle]);

  const setupTimer = () => {
    const targetTime = Date.now() + debounceTime;

    timeoutRef.current = setTimeout(() => {
      handleOnIdle();
    }, debounceTime);

    intervalRef.current = setInterval(() => {
      const timeLeft = targetTime - Date.now();
    }, 1000);
  };

  const clearTimer = () => {
    clearTimeout(timeoutRef.current);
    clearInterval(intervalRef.current);
    setIsDisconnecting(false); // Reset flag when clearing the timer
  };

  useEffect(() => {
    try {
      paramMemoire.map((item) => {
        
        setisLogged(item.isLoggedIn2)
        setuserEmail(item.emaiUtulisateur)
        settypeUtilisateur(item.typeUtilisateur);

        setUserID(item.id);
        setRole(item.role);
        setUniversityID(item.universityID);
        setUniversityIDDisplay(item.university);
        setAlterarSenha(item.alterarSenha);

        setfirstname(item.firstname);
        setlastname(item.lastname);
        setuniversityOuCollege(item.universityOuCollege)

     // //    alert("item.typeUtilisateur###    " + item.role)
       
        if(Number(item.typeUtilisateur) ===1) {

         //   getallDispatchData(item.universityID, item.id, item.role);
         getallDispatchDataFacultyAndRest(item.universityID, item.id, item.role);
        }

        if(Number(item.typeUtilisateur) ===2) {
          fetchProfessorDataProf(item.universityID,
            item.currentYear, item.professorID);
        }

        if(Number(item.typeUtilisateur) ===3) {
          fetchStudentData(item.universityID, item.studentMatriculaID,
           item.maxYearStudent, item.studentNumber );
           setuserIDStudent(item.userID)
        }
    
      });
    } catch (e) {}
  }, [role, typeUtilisateur, universityOuCollege]);
// }, [paramMemoire]);

  

  /* const getallDispatchData = async (univID, userID1, role1) => {
    await fetchProfessorDataUniversity(univID);
  
  } */
  const getallDispatchDataFacultyAndRest = async (univID, userID1, role1) => 
  {

    return Promise.all([
      
       dispatch(getFaculty("Generalanfilter", userID1, role1, univID)),
       dispatch(getFacultyForConfigOnly("Generalanfilter", univID)),
        dispatch(gteDepartement("departementsSamsFilterAdmin", userID1, role1, univID)),
        dispatch(getTurno("General-san-filter", univID)),

       dispatch(getAcademicYear("General-san-filter", univID)),

       dispatch(getTurma("General-san-filter")),
       dispatch(getCoursDuration("All_coursDuration", univID)),
       dispatch(getAllAnneeAcademiqueStudents("101", univID)),
       dispatch(getAllAnneeAcademique("101", univID))

    

    
  ])

   /*  setImmediate(async () => {
      console.log("layout_headerDispatches are now executing in the background...");
      console.time("Layout_execution_fetchGeneralData Execution Time");
  
      try {
          // Step 1: Fetch Faculty Data
          console.log("Fetching Faculty Data...");
          await dispatch(getFaculty("Generalanfilter", userID1, role1, univID));
          await dispatch(getFacultyForConfigOnly("Generalanfilter", univID));
  
          //  Add a small delay to allow Redux state to update
          await new Promise(resolve => setTimeout(resolve, 500));
  
          // Debug: Check if Faculty data is properly set
          console.log(" Faculty Data Loaded:", JSON.stringify(getState().faculty, null, 2));
  
          // Step 2: Fetch Departments (After Faculty is loaded)
          console.log("Fetching Departments...");
          await dispatch(gteDepartement("departementsSamsFilterAdmin", userID1, role1, univID));
  
          // Debug: Ensure allowedData contains correct data before filtering
          console.log(" Allowed Data:", JSON.stringify(getState().departments.allowedData?.slice(0, 5), null, 2));
  
          // Step 3: Fetch Academic Year
          console.log("Fetching Academic Year...");
          await dispatch(getAcademicYear("General-san-filter", univID));
  
          // Step 4: Continue with other parallel requests
          console.log("Fetching Remaining Data...");
          await Promise.all([
              dispatch(getTurma("General-san-filter")),
              dispatch(getCoursDuration("All_coursDuration", univID)),
              dispatch(getAllAnneeAcademiqueStudents("101", univID)),
              dispatch(getAllAnneeAcademique("101", univID))
          ]);
  
          console.timeEnd("Layout_execution_fetchGeneralData Execution Time");
          console.log(" Layout header: All dispatches finished running in the background.");
  
      } catch (error) {
          console.error(" Error in fetchGeneralData:", error);
      }
  }); */

  };

 /*  const fetchProfessorDataUniversity = async (univID) => 
  {
    return Promise.all([
        dispatch(getUniversity("GetUnniversityForCombobox")),
        
        ]);
    } */

    // Application
const fetchStudentData = async (universityID1, studentMatriculaID, maxYearStudent, studentNumber) => {

     // **Essential API Calls - Execute Immediately**
    Promise.all([
      dispatch(getCoursDurationStudentApi("All_coursDuration", universityID1)),
      dispatch(getUniversityStudentApi("GetUnniversityForCombobox")),
       dispatch(getYearStudentCoursDistinctStudentApi(studentMatriculaID, "getYear_studentCours_distinct")),
      dispatch(getAllStudentCoursAccessEstudantStudentApi(studentMatriculaID)),
      dispatch(getPAymentCaisseStudentStudentApi(studentMatriculaID, 2, maxYearStudent, "portail-etudiant-New", universityID)),
      dispatch(getPaymentsmouvementsStudentApi(studentMatriculaID, universityID1, "portail-etudiant-New-studentPaymentPortailNewRedux")),
       dispatch(getSaldoEstudentStudentApi(universityID, studentNumber)),
      dispatch(getCurrencyAll(universityID1, "currencyGetAl"))
    ])
    .then(() => {
      console.log(" Essential layout header data loaded.");
  
      // **Defer Non-Essential API Calls in the Background**
    
    })
    .catch(error => console.error(" Error in essential data fetch:", error));
  
  
  //  Call the function where needed
  // fetchLayoutHeaderData();
  
 /*  return Promise.all([
    dispatch(getCoursDurationStudentApi("All_coursDuration", universityID1)),
   dispatch(getUniversityStudentApi("GetUnniversityForCombobox")),
    dispatch(getYearStudentCoursDistinctStudentApi(studentMatriculaID, "getYear_studentCours_distinct")),
   dispatch(getAllStudentCoursAccessEstudantStudentApi(studentMatriculaID)),
   dispatch(getPAymentCaisseStudentStudentApi(studentMatriculaID, 2, maxYearStudent, "portail-etudiant-New", universityID)),
   dispatch(getPaymentsmouvementsStudentApi(studentMatriculaID, universityID1, "portail-etudiant-New-studentPaymentPortailNewRedux")),
    dispatch(getSaldoEstudentStudentApi(universityID, studentNumber)),
   dispatch(getCurrencyAll(universityID1, "currencyGetAl"))
  ]); */

};

const fetchProfessorData = async (universityID, userID1, role1) => {

  setImmediate(() => {
    Promise.all([
      dispatch(getCalendarioAvaliation(1, "getAllCalendario", universityID)),
      dispatch(getAllUser("getAllUserRedux", universityID))
    ])
    .catch(error => console.error("Error in Promise.all:", error));
  });
  
  // Return immediately to avoid blocking
  return Promise.resolve();

 /*  return Promise.all([
  dispatch(getCalendarioAvaliation(1, "getAllCalendario", universityID)),
  dispatch(getAllUser("getAllUserRedux", universityID)),
  ]); */
  }
  const getdadosLoginFalse = async () => {
    const response = await getUserEmailUpdateData(userEmail);
    const testData = response.data;
    
   // console.log("testDatawer###### ", testData)
    setParamMemoire([
      {
        ...testData.user, // Spreading all existing properties of the user object
        isLoggedIn2: false,
        enligne: 0 // Adding or overriding the `isLoggedIn2` property
      },
    ]) 
  }


  return (
    <>
      <Box sx={{ width: 228, display: 'flex', [theme.breakpoints.down('md')]: { width: 'auto' } }}>
        <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
          <LogoSection />
        </Box>
        {Number(alterarSenha) !== 2 && (
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              overflow: 'hidden',
              transition: 'all .2s ease-in-out',
              background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
              color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
              '&:hover': {
                background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                color: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.light
              }
            }}
            onClick={() => dispatch(openDrawer(!drawerOpen))}
          >
            <IconMenu2 stroke={1.5} size="1.3rem" />
          </Avatar>
        )}
      </Box>
      <SigucVersion />
      <Box sx={{ flexGrow: 1 }} />

      {(Number(role) <=4  || Number(role)  ===101  || role === undefined ) ?
      
      <MegaMenuSection />
      : null
      }

      <LocalizationSection />

      {Number(alterarSenha) !== 2 && (
      <NotificationSection />
      )}

     {/* eryyyg */}

      <ProfileSection />
      <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
        <MobileSection />
      </Box>
          
          <div>
      {showExpiredComponent && (
        <PopupNew
          openPopup={showExpiredComponent}
          setOpenPopup={setshowExpiredComponent} // Ensure you toggle state here
          title={"Session Expired"}
          width="500px"
          height="200px"
        > 
          <ShowSessionExpiredAlert
          abreviaturaUniversidade={abreviaturaUniversidade}
          handleRedirection = {handleRedirection}
         /*  onConfirm={() => {
            console.log("Session expired! Handle additional cleanup if needed.");
          }} */
        
        />        
          </PopupNew>
      )}
    </div>


    </>
  );
};

export default Header;

